import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
    baseURL: `${BACKEND_URL}/api`,
    withCredentials: true,
});

// Attach bearer token fallback (if cookie blocked)
api.interceptors.request.use((config) => {
    const t = localStorage.getItem("token");
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

// On 401, clear local session and bounce to /login (except for /auth/me which is allowed to probe)
let onUnauthorized = null;
export function setUnauthorizedHandler(fn) {
    onUnauthorized = fn;
}
api.interceptors.response.use(
    (r) => r,
    (error) => {
        const status = error?.response?.status;
        const url = error?.config?.url || "";
        const isAuthProbe =
            url.includes("/auth/me") ||
            url.includes("/auth/login") ||
            url.includes("/auth/register") ||
            url.includes("/apertura/lock") ||
            url.includes("/apertura/unlock");
        if (status === 401 && !isAuthProbe && onUnauthorized) {
            onUnauthorized();
        }
        return Promise.reject(error);
    },
);

export function formatApiError(detail) {
    if (detail == null) return "Qualcosa è andato storto.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export function euro(n) {
    if (n === null || n === undefined || isNaN(n)) return "0,00 €";
    return new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: "always",
    }).format(n);
}

// Plain italian number formatter (no currency symbol). Always groups thousands and forces 2 decimals.
export function num(n) {
    if (n === null || n === undefined || isNaN(n)) return "0,00";
    return new Intl.NumberFormat("it-IT", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: "always",
    }).format(n);
}

export function shortDate(iso) {
    if (!iso) return "";
    try {
        const d = new Date(iso);
        return d.toLocaleDateString("it-IT", {
            day: "2-digit",
            month: "short",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return iso;
    }
}

export const TX_LABELS = {
    entrata: "Entrata (deprecato)",
    uscita: "Spesa",
    trasferimento: "Trasferimento",
    vendita_credito: "Vendita Credito",
    rientro_fido: "Versamento Provider",
    scarico_plusvalenza: "Scarico Plusvalenza",
    accredito: "Accredito",
    sospeso: "Sospeso",
    rientro_sospeso: "Versamento Cliente",
    prelievo_utili: "Prelievo Utili",
    incasso_pos: "Incasso POS",
    apporto_capitale: "Apporto Capitale",
    prelievo_capitale: "Rimborso Capitale",
    restituzione_cliente: "Restituzione al Cliente",
    service_adjustment: "Rettifica Service",
};

export function pct(n) {
    if (n === null || n === undefined || isNaN(n)) return "—";
    return `${n.toFixed(1)}%`;
}
